import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as jwt_decode from 'jwt-decode';
import { withRouter } from 'react-router-dom';
import { Layout, Row, Col, Table, DatePicker, Select, Spin } from 'antd';
import moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUserData, getDataUserCompany } from '../../redux/actions';

import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Breadcrumb from '../../components/Breadcrumb';

import Service from './Service';
import './styles.css';

const { Content } = Layout;
const { Option } = Select;

// Cada zona tem uma cor de fundo própria na tabela (ver styles.css).
const CLASSES_ZONA_BLUE = {
  Vermelha: 'zona-vermelha',
  Amarela: 'zona-amarela',
  Verde: 'zona-verde',
  Blue: 'zona-azul',
  'Sem dados': 'zona-sem-dados',
};

const CLASSES_ZONA_NPS = {
  'Crítica': 'zona-vermelha',
  'Aperfeiçoamento': 'zona-amarela',
  'Qualidade': 'zona-verde',
  'Excelência': 'zona-azul',
  'Sem dados': 'zona-sem-dados',
};

// DATE_FORMAT e o formato que o back-end espera na URL e que guardamos no
// state - nao mudar. FORMATO_EXIBICAO e so o que o usuario ve no campo.
// Cuidado no onChange: o antd entrega a data ja formatada conforme
// FORMATO_EXIBICAO, entao a string dele NAO serve pra chamar a API.
const DATE_FORMAT = 'YYYY-MM-DD';
const FORMATO_EXIBICAO = 'DD/MM/YYYY';
const DATE_INITIAL = moment(
  new Date(new Date().setDate(new Date().getDate() - 30))
).format(DATE_FORMAT);
const DATE_FINAL = moment(new Date()).format(DATE_FORMAT);

class Indicadores extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      empresas: [],
      idEmpresa: 0,
      dataInicial: DATE_INITIAL,
      dataFinal: DATE_FINAL,
      resumo: null,
      expandedRowKeys: [],
      // Muda so quando resumo/expandedRowKeys mudam de verdade (incrementado
      // dentro de loadResumo, no mesmo setState dos dois). idEmpresa sozinho
      // NAO serve pra isso: ele e setado assim que o usuario escolhe a
      // empresa, ANTES da busca terminar - usa-lo remontava a tabela cedo
      // demais, com dado antigo, e quando o dado certo chegava a chave ja
      // nao mudava mais (idEmpresa ja estava no valor final).
      resumoVersion: 0,
      sortField: 'nps',
      sortOrder: 'descend',
      loading: false,
    };

    this.service = new Service();
  }

  componentDidMount() {
    if (!this.service.isLogged()) {
      this.props.history.push('/login');
    } else {
      const tokenLogin = localStorage.getItem('token');
      const decodeToken = jwt_decode(tokenLogin);
      this.setState({
        role: decodeToken.role,
        dataUser: decodeToken,
      });

      this.loadEmpresas();
    }
  }

  loadEmpresas = async () => {
    this.setState({ loading: true });

    const result = await this.service.listCompany();

    if (result === undefined) {
      await this.service.doLogout();
      this.props.history.push('/login');
      return;
    }

    const empresas = result.object || [];
    this.props.getDataUserCompany(empresas);

    // Se o usuário já escolheu um grupo no Header, começa por ele.
    const idEmpresaHeader =
      this.props.companySelected.length > 0
        ? this.props.companySelected[0].id
        : 0;

    const idEmpresa = empresas.some(e => e.id === idEmpresaHeader)
      ? idEmpresaHeader
      : empresas.length > 0
      ? empresas[0].id
      : 0;

    this.setState({ empresas, idEmpresa, loading: false });

    if (idEmpresa > 0) {
      this.loadResumo(idEmpresa, this.state.dataInicial, this.state.dataFinal);
    }
  };

  loadResumo = async (idEmpresa, dataInicial, dataFinal) => {
    this.setState({ loading: true });

    const result = await this.service.getResumoIndicadores(
      dataInicial,
      dataFinal,
      idEmpresa
    );

    const resumo = result && result.object ? result.object : null;

    // A linha da empresa já vem aberta, mostrando as filiais (como no layout de referência).
    const expandedRowKeys =
      resumo && resumo.empresa ? [`empresa-${resumo.empresa.id}`] : [];

    this.setState(state => ({
      resumo,
      expandedRowKeys,
      loading: false,
      resumoVersion: state.resumoVersion + 1,
    }));
  };

  // Nao alimenta mais nenhum estado: expandedRowKeys agora e passado como
  // defaultExpandedRowKeys (nao-controlado). Diagnostico confirmado ao vivo
  // (2026-08-09): o antd 3 (rc-table antigo), ao receber um dataSource novo,
  // chama onExpandedRowsChange([]) por CONTA PROPRIA logo apos a gente setar
  // a chave certa - nao e um clique do usuario. Como o handler antigo
  // aceitava isso cegamente (this.setState({ expandedRowKeys })), o proprio
  // antd desfazia a abertura um instante depois de acontecer, toda vez.
  // Deixado vazio de proposito: com defaultExpandedRowKeys, esse callback
  // deixa de ter qualquer efeito sobre o que aparece expandido.
  onExpandedRowsChange = () => {};

  onChangeOrdenacao = (pagination, filters, sorter) => {
    this.setState({
      sortField: sorter.order ? sorter.field : null,
      sortOrder: sorter.order || null,
    });
  };

  ordenarFiliais = filiais => {
    const { sortField, sortOrder } = this.state;

    if (!sortField || !sortOrder) {
      return filiais;
    }

    const dir = sortOrder === 'ascend' ? 1 : -1;

    return filiais.slice().sort((a, b) => {
      if (sortField === 'nome') {
        return dir * String(a.nome || '').localeCompare(String(b.nome || ''));
      }
      return dir * ((a[sortField] || 0) - (b[sortField] || 0));
    });
  };

  onChangeEmpresa = idEmpresa => {
    this.setState({ idEmpresa });
    this.loadResumo(idEmpresa, this.state.dataInicial, this.state.dataFinal);
  };

  onChangeData = (value, dateString) => {
    // Le dos objetos moment (1o argumento), NAO de dateString: essa vem no
    // formato de exibicao (dd/mm/aaaa) e a API espera aaaa-mm-dd.
    const dataInicial = value && value[0] ? value[0].format(DATE_FORMAT) : '';
    const dataFinal = value && value[1] ? value[1].format(DATE_FORMAT) : '';

    this.setState({ dataInicial, dataFinal });

    if (dataInicial && dataFinal && this.state.idEmpresa > 0) {
      this.loadResumo(this.state.idEmpresa, dataInicial, dataFinal);
    }
  };

  formatPercent = valor =>
    `${(valor || 0).toFixed(1).replace('.', ',')}%`;

  formatQuantidadePercent = (total, percent) =>
    `${total || 0} (${this.formatPercent(percent)})`;

  montarLinha = (item, isEmpresa) => ({
    key: isEmpresa ? `empresa-${item.id}` : `filial-${item.id}`,
    isEmpresa,
    ...item,
  });

  montarDataSource = () => {
    const { resumo } = this.state;

    if (!resumo || !resumo.empresa) {
      return [];
    }

    const linhaEmpresa = this.montarLinha(resumo.empresa, true);

    linhaEmpresa.children = this.ordenarFiliais(resumo.filiais || []).map(
      filial => this.montarLinha(filial, false)
    );

    return [linhaEmpresa];
  };

  render() {
    const { RangePicker } = DatePicker;

    const columns = [
      {
        title: 'Empresa',
        dataIndex: 'nome',
        sorter: true,
        sortOrder: this.state.sortField === 'nome' ? this.state.sortOrder : false,
      },
      {
        title: 'Avaliações',
        dataIndex: 'totalAvaliacao',
        sorter: true,
        sortOrder:
          this.state.sortField === 'totalAvaliacao' ? this.state.sortOrder : false,
      },
      {
        title: 'Índice Blue',
        dataIndex: 'indiceBlue',
        sorter: true,
        sortOrder:
          this.state.sortField === 'indiceBlue' ? this.state.sortOrder : false,
        render: (text, record) => ({
          children:
            record.zonaBlue === 'Sem dados' ? '-' : Math.round(record.indiceBlue || 0),
          props: { className: CLASSES_ZONA_BLUE[record.zonaBlue] || '' },
        }),
      },
      {
        title: 'Zona Blue',
        render: (text, record) => ({
          children: record.zonaBlue,
          props: { className: CLASSES_ZONA_BLUE[record.zonaBlue] || '' },
        }),
      },
      {
        title: 'NPS',
        dataIndex: 'nps',
        sorter: true,
        sortOrder: this.state.sortField === 'nps' ? this.state.sortOrder : false,
        render: (text, record) => ({
          children:
            record.zonaNps === 'Sem dados' ? '-' : Math.round(record.nps || 0),
          props: { className: CLASSES_ZONA_NPS[record.zonaNps] || '' },
        }),
      },
      {
        title: 'Zona do NPS',
        render: (text, record) => ({
          children: record.zonaNps,
          props: { className: CLASSES_ZONA_NPS[record.zonaNps] || '' },
        }),
      },
      {
        title: 'Críticas',
        dataIndex: 'totalCriticas',
        sorter: true,
        sortOrder:
          this.state.sortField === 'totalCriticas' ? this.state.sortOrder : false,
        render: (text, record) => (
          <span className="indicador-critica">
            {this.formatQuantidadePercent(
              record.totalCriticas,
              record.percentCriticas
            )}
          </span>
        ),
      },
      {
        title: 'Elogios',
        dataIndex: 'totalElogios',
        sorter: true,
        sortOrder:
          this.state.sortField === 'totalElogios' ? this.state.sortOrder : false,
        render: (text, record) => (
          <span className="indicador-elogio">
            {this.formatQuantidadePercent(
              record.totalElogios,
              record.percentElogios
            )}
          </span>
        ),
      },
      {
        title: 'Detratores',
        dataIndex: 'totalDetratores',
        sorter: true,
        sortOrder:
          this.state.sortField === 'totalDetratores' ? this.state.sortOrder : false,
        render: (text, record) => (
          <span className="indicador-detrator">
            {this.formatQuantidadePercent(
              record.totalDetratores,
              record.percentDetratores
            )}
          </span>
        ),
      },
      {
        title: 'Neutros',
        dataIndex: 'totalNeutros',
        sorter: true,
        sortOrder:
          this.state.sortField === 'totalNeutros' ? this.state.sortOrder : false,
        render: (text, record) => (
          <span className="indicador-neutro">
            {this.formatQuantidadePercent(
              record.totalNeutros,
              record.percentNeutros
            )}
          </span>
        ),
      },
      {
        title: 'Promotores',
        dataIndex: 'totalPromotores',
        sorter: true,
        sortOrder:
          this.state.sortField === 'totalPromotores' ? this.state.sortOrder : false,
        render: (text, record) => (
          <span className="indicador-promotor">
            {this.formatQuantidadePercent(
              record.totalPromotores,
              record.percentPromotores
            )}
          </span>
        ),
      },
    ];

    const homeClient = {
      home: 'Início',
      user: 'Índice Blue',
      company: 'NPS',
      companyClient: 'Empresa',
      contracts: 'Evoluções',
      plans: 'Avaliações',
      indicadores: 'Visão Geral',
      configuration: 'Opções',
      logout: 'Sair',
      iconClient: {
        home: 'home',
        user: 'area-chart',
        company: 'pie-chart',
        companyClient: 'bank',
        contracts: 'line-chart',
        plans: 'message',
        indicadores: 'dashboard',
        configuration: 'setting',
        logout: 'logout',
      },
    };

    const routesClient = {
      home: 'client',
      user: 'indexBlue',
      company: 'nps',
      companyClient: 'companyClient',
      contracts: 'evolution',
      plans: 'comments',
      indicadores: 'indicadores',
      configuration: 'settings',
    };

    return (
      <Layout>
        <Sidebar
          dataSidebar={homeClient}
          routes={routesClient}
          current="indicadores"
        />
        <Layout>
          {/* Esta tela ja tem seletor de empresa proprio (na tabela) -
              esconde o do Header pra nao sugerir uma acao que nao tem
              efeito nenhum aqui (ver comentario em Header/index.js). */}
          <Header dataUser={this.state.dataUser} esconderSeletorUnidade />

          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
            }}
          >
            <Spin spinning={this.state.loading} size="large">
              <Row className="nopadding-col">
                <Col md={{ span: 16 }} xs={{ span: 24 }}>
                  <Breadcrumb pages={[{ title: 'Visão Geral' }]} />
                </Col>
              </Row>

              <Row className="filtros-indicadores">
                <Select
                  className="select-empresa"
                  placeholder="Selecione uma empresa"
                  value={this.state.idEmpresa > 0 ? this.state.idEmpresa : undefined}
                  onChange={this.onChangeEmpresa}
                >
                  {this.state.empresas.map(empresa => (
                    <Option key={empresa.id} value={empresa.id}>
                      {empresa.nome}
                    </Option>
                  ))}
                </Select>

                <RangePicker
                  value={[
                    moment(this.state.dataInicial, DATE_FORMAT),
                    moment(this.state.dataFinal, DATE_FORMAT),
                  ]}
                  format={FORMATO_EXIBICAO}
                  onChange={this.onChangeData}
                />
              </Row>

              <Row>
                <Col span={24}>
                  <Table
                    // Forca a tabela a remontar do zero toda vez que um
                    // resumo novo chega (resumoVersion so incrementa junto
                    // com expandedRowKeys, no mesmo setState de loadResumo -
                    // nao usa idEmpresa, que muda ANTES da busca terminar e
                    // remontaria cedo demais, com dado antigo ainda na tela).
                    //
                    // O remount e necessario porque expandedRowKeys agora e
                    // NAO-CONTROLADO (defaultExpandedRowKeys, nao
                    // expandedRowKeys): diagnostico ao vivo (2026-08-09)
                    // confirmou que o antd 3 chama onExpandedRowsChange([])
                    // por CONTA PROPRIA sempre que dataSource muda, desfazendo
                    // a abertura um instante depois de acontecer - mesmo sem
                    // nenhum clique do usuario. defaultExpandedRowKeys so e
                    // lido na montagem, entao remontar a cada resumo novo e o
                    // unico jeito de aplicar a chave certa sem o antd
                    // "corrigir" sozinho.
                    key={this.state.resumoVersion}
                    className="tabela-indicadores"
                    columns={columns}
                    dataSource={this.montarDataSource()}
                    loading={this.state.loading}
                    pagination={false}
                    size="middle"
                    scroll={{ x: 1100 }}
                    rowClassName={record =>
                      record.isEmpresa ? 'row-empresa' : 'row-filial'
                    }
                    defaultExpandedRowKeys={this.state.expandedRowKeys}
                    onExpandedRowsChange={this.onExpandedRowsChange}
                    onChange={this.onChangeOrdenacao}
                  />
                </Col>
              </Row>
            </Spin>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

Indicadores.propTypes = {
  history: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getUserData, getDataUserCompany }, dispatch);

const mapStateToProps = store => ({
  userData: store.userData.data,
  dataUserCompany: store.userData.dataUserCompany,
  companySelected: store.userData.companySelected,
  dataFilial: store.userData.dataFilial,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Indicadores));
